{
  "headTitle": "Flow",
  "empty": {
    "title": "Add your first node",
    "hint": "Press “+”, double-click the board, or right-click to open the menu.\nYou can also drop an image, video, or audio file here.\nPaste an image from the clipboard with Ctrl+V or ⌘V."
  },
  "switcher": {
    "aria": "Flow boards",
    "create": "New board",
    "renameTitle": "Rename board",
    "renameName": "Name",
    "deleteTitle": "Delete board",
    "deleteConfirm": "Delete “{{title}}”? Nodes on this board will be removed."
  },
  "viewport": {
    "map": "Map",
    "showMap": "Show map",
    "hideMap": "Hide map",
    "zoomMenu": "Zoom, {{percent}}",
    "zoom100": "Zoom 100%",
    "zoomFit": "Zoom to fit",
    "addNode": "Add node",
    "arrange": "Arrange nodes",
    "arrangeSelection": "Arrange selection",
    "arrangeBoard": "Arrange board"
  },
  "menu": {
    "upload": "Upload file",
    "library": "Choose from library",
    "image": "Image",
    "video": "Video",
    "videoTransition": "Video transition",
    "audio": "Audio",
    "upscale": "Upscaling Video",
    "depth": "Depth map",
    "shot": "Shot",
    "character": "Character",
    "location": "Location",
    "prop": "Prop",
    "noCharacters": "This project has no characters",
    "noLocations": "This project has no locations",
    "noProps": "This project has no props",
    "newShot": "New",
    "back": "Back",
    "noScenes": "This project has no scenes",
    "shotsLoading": "Loading…",
    "shotsLoadFailed": "Could not load shots",
    "episode": "Episode {{label}}",
    "delete": "Delete node",
    "edit": "Edit",
    "createChain": "Create chain",
    "regenerate": "Generate",
    "editChain": "Edit chain",
    "duplicate": "Duplicate",
    "chainActions": "Chain actions",
    "search": "Find a node, character, location…",
    "searchIn": "Search: {{title}}",
    "searchConnect": "What to connect?",
    "noResults": "Nothing found for “{{query}}”",
    "noChains": "No chains yet",
    "pin": "Pin",
    "unpin": "Unpin",
    "filters": {
      "all": "All",
      "gen": "Generate",
      "media": "Media",
      "project": "Project",
      "chains": "Chains"
    },
    "sections": {
      "pinned": "Pinned",
      "gen": "Generate",
      "media": "Media",
      "project": "From project",
      "chains": "Chains",
      "nodes": "Nodes",
      "connect": "Can connect"
    },
    "subs": {
      "generate": "Generation",
      "videoTransition": "First frame, last frame, or both",
      "postProduction": "Post-production",
      "depth": "Black and white or color",
      "upload": "Image or video from disk",
      "audio": "Audio file from disk",
      "library": "Project assets",
      "shot": "From the storyboard",
      "chain": "Chain"
    },
    "counts": {
      "characters_one": "{{count}} character",
      "characters_other": "{{count}} characters",
      "locations_one": "{{count}} location",
      "locations_other": "{{count}} locations",
      "props_one": "{{count}} prop",
      "props_other": "{{count}} props",
      "shots_one": "{{count}} shot",
      "shots_other": "{{count}} shots"
    }
  },
  "node": {
    "empty": "No result yet",
    "upscaleEmpty": "Connect a video",
    "depthEmpty": "Connect a video",
    "failed": "Generation failed",
    "shotMissing": "Shot is unavailable",
    "chainMissing": "Chain was deleted",
    "characterMissing": "Character is unavailable",
    "locationMissing": "Location is unavailable",
    "propMissing": "Prop is unavailable",
    "untitled": "Untitled",
    "rename": "Name",
    "download": "Download original",
    "kinds": {
      "upload": "File",
      "library": "Library",
      "image": "Image",
      "video": "Video",
      "video_transition": "Video transition",
      "audio": "Audio",
      "video_upscale": "Upscale",
      "video_depth": "Depth",
      "chain": "Chain",
      "shot": "Shot",
      "character": "Character",
      "location": "Location",
      "prop": "Prop"
    }
  },
  "player": {
    "mute": "Mute",
    "unmute": "Unmute"
  },
  "edges": {
    "input": "References",
    "output": "Image",
    "videoInput": "Video",
    "videoOutput": "Video",
    "entityOutput": "Entity",
    "audioOutput": "Audio",
    "shotInput": "Shot links",
    "firstFrame": "First frame",
    "lastFrame": "Last frame",
    "makeKeyframe": "Set as key frame",
    "references": "Connected references"
  },
  "versions": {
    "title": "Versions",
    "deleteConfirm": "Delete this version?"
  },
  "column": {
    "boardAssistant": "Board assistant",
    "nodeAssistant": "Node assistant",
    "prompt": "Prompt",
    "assistant": "Assistant",
    "generate": "Generate",
    "generating": "Generating…",
    "promptPlaceholder": "Describe the frame",
    "framesRequired": "Connect a first frame, a last frame, or both",
    "frameSlotEmpty": "Connect an image",
    "referencesEmpty": "Attach references by connecting them on the board"
  },
  "chain": {
    "created": "Chain created",
    "duplicated": "Chain duplicated",
    "run": "Run",
    "running": "In progress…",
    "image": "Image",
    "video": "Video",
    "attachHint": "Attach a node to the chain input",
    "upload": "Upload a file",
    "library": "Library",
    "disconnect": "Disconnect",
    "back": "Back",
    "backTo": "Back to {{title}}",
    "delete": "Delete",
    "deleteTitle": "Delete chain",
    "deleteConfirm": "Delete “{{title}}”? Placed nodes stay on the board without the chain.",
    "renameTitle": "Rename chain",
    "input": "Input",
    "makeInput": "Make input",
    "cancelInput": "Cancel",
    "inputEmpty": "Chain input",
    "inputEmptyHint": "A file is filled in when the chain runs",
    "starterChoice": "Generate it or make it a chain input",
    "nestedInputs": "This chain has its own inputs. Add input nodes, connect them, and mark those as inputs."
  },
  "depth": {
    "variant": "Color",
    "gray": "Black and white",
    "color": "Color",
    "model": "Video Depth Anything Small"
  },
  "upscale": {
    "source": "Source",
    "needsSource": "Connect a video or a shot",
    "video": "Video",
    "disconnect": "Disconnect",
    "model": "Model",
    "version": "Version",
    "noModels": "No enhancement models available"
  },
  "bulk": {
    "title": "Generate",
    "cancel": "Cancel",
    "confirm": "Generate",
    "summary": "{{list}} will be generated for {{price}}.",
    "summaryUnknown": "{{list}} will be generated.",
    "and": "and",
    "quoteFailed": "Could not estimate the cost",
    "startFailed": "Could not start generation",
    "queued": "This node is already queued for generation",
    "deleteTitle": "Node is waiting to generate",
    "deleteNode": "This node is waiting to generate. Deleting it cancels it and everything that depends on it in this run.",
    "deleteNodes": "Some nodes are waiting to generate. Deleting them cancels them and everything that depends on them in this run.",
    "deleteEdge": "Deleting this connection cancels everything that depends on it in this run.",
    "kinds": {
      "image_one": "{{count}} image",
      "image_other": "{{count}} images",
      "video_one": "{{count}} video",
      "video_other": "{{count}} videos",
      "video_transition_one": "{{count}} video transition",
      "video_transition_other": "{{count}} video transitions",
      "video_upscale_one": "{{count}} upscale",
      "video_upscale_other": "{{count}} upscales",
      "video_depth_one": "{{count}} depth map",
      "video_depth_other": "{{count}} depth maps",
      "chain_one": "{{count}} chain",
      "chain_other": "{{count}} chains",
      "shot_one": "{{count}} shot",
      "shot_other": "{{count}} shots"
    }
  },
  "errors": {
    "createFailed": "Could not create the board",
    "renameFailed": "Could not rename the board",
    "deleteFailed": "Could not delete the board",
    "nodeFailed": "Could not update the node",
    "generateFailed": "Could not start generation"
  }
}
